// removed by extract-text-webpack-plugin
module.exports = {"collapsedPayment":"_2DoC_","text":"_2socL","icon":"_3rYJ5","payPal":"RVdAR"};


//////////////////
// WEBPACK FOOTER
// ./components/CollapsedPayment/CollapsedPayment.scss
// module id = 363
// module chunks = 0 1